import { collectionFeatures } from '@/mocks/homeData';
import { useToast } from '@/hooks/useToast';

export default function FeatureCollection() {
  const { show, node } = useToast();

  return (
    <section id="features" className="px-4 md:px-8 pt-16 md:pt-28">
      <div className="mx-auto max-w-6xl">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <span className="text-xs tracking-[0.25em] text-primary-600">深扒专题合集</span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              把零散爆料收成一条线
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
              每个专题都从素材出发，先排时间顺序，再逐条对照口径，最后给出可复核的证据位置。
            </p>
          </div>
          <button
            type="button"
            onClick={() => show('专题合集列表即将上线，当前为演示入口')}
            className="self-start md:self-auto flex items-center gap-2 px-4 py-2.5 text-sm rounded-md border border-background-300 text-foreground-700 whitespace-nowrap transition-colors cursor-pointer hover:border-primary-300 hover:text-primary-600"
          >
            <i className="ri-stack-line w-4 h-4 flex items-center justify-center" />
            全部专题
          </button>
        </div>

        <div className="mt-8 md:mt-12 grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
          {collectionFeatures.map((item) => (
            <article
              key={item.title}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 overflow-hidden transition-colors hover:border-primary-300"
            >
              <div className="relative w-full h-48 md:h-52 overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.title} 专题封面`}
                  title={`${item.title} 深度梳理`}
                  className="w-full h-full object-cover object-top"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-background-50/95 text-[11px] font-medium text-primary-700">
                  {item.tag}
                </span>
              </div>

              <div className="flex flex-col flex-1 p-5 md:p-6">
                <a
                  href="#timeline"
                  className="font-heading text-lg font-bold leading-snug text-foreground-950 cursor-pointer transition-colors hover:text-primary-600"
                >
                  {item.title}
                </a>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">
                  {item.summary}
                </p>

                <div className="mt-5 flex flex-wrap gap-2">
                  {item.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-900 text-[11px] whitespace-nowrap"
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                <div className="mt-5 pt-4 flex items-center justify-between border-t border-background-200">
                  <span className="flex items-center gap-3 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line w-4 h-4 flex items-center justify-center" />
                      {item.readTime}
                    </span>
                    <span>{item.date}</span>
                  </span>
                  <button
                    type="button"
                    onClick={() => show('已加入收藏，更新时会第一时间告诉你')}
                    className="flex items-center justify-center w-8 h-8 rounded-md border border-background-300 text-foreground-600 transition-colors cursor-pointer hover:border-accent-400 hover:text-accent-700"
                    aria-label="收藏专题"
                  >
                    <i className="ri-bookmark-line w-4 h-4 flex items-center justify-center" />
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
      {node}
    </section>
  );
}